import { render } from "./AppPassword.vue?vue&type=template&id=2a4f9e92"
import script from "./AppPassword.vue?vue&type=script&lang=ts"
export * from "./AppPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script